module.exports = __webpack_public_path__ + "static/media/5.2030f5b8.jpg";